// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B1BP","newExpiryDate":"styles_newExpiryDate__3-bH2","footer":"styles_footer__Trpvz"};